import {DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import {ActionPopup} from "components/Admin/Pages/ActionPopup/ActionPopup";
import {useQueryUpdater} from "hooks/useQueryUpdater";
import {Params, useParams} from "react-router";
import {has} from "lodash";
import {useResourceContext, useTranslate} from "react-admin";
import {useId} from "../../../../hooks/useId";

type DeletePopupProps<TResult> = {
  queryKey?: string;
  paramName?: string;
  title?: string;
  message?: string;
  onSuccess?: (data: TResult) => void;
  submitButtonText?: string;
  cancelButtonText?: string;
  successMessage?: string;
  deleteQuery: (props: { id: any }) => Promise<TResult>;
  onSuccessNavigate?: string;
};

export const DeletePopup: <TResult>(
  props: DeletePopupProps<TResult>
) => JSX.Element = (props) => {
  const t = useTranslate();

  const params: Params<string> = useParams();

  const resource = useResourceContext();

  const queryKey = props.queryKey ?? resource;

  if (!queryKey) {
    throw new Error("Query key or resource key is required");
  }

  const {deleteEntity} = useQueryUpdater({
    queryKey,
  });

  const id = useId();

  return (
    <ActionPopup
      queryKey={queryKey}
      submitQuery={() => props.deleteQuery({id})}
      submitButtonText={t("ra.action.delete")}
      cancelButtonText={t("ra.action.cancel")}
      successMessage={t("ra.notification.deleted")}
      onSuccess={props.onSuccess}
      onSuccessNavigate={props.onSuccessNavigate}
      updateCacheFn={() => deleteEntity((entity) => {
        if (has(entity, "id") && entity.id === id) {
          return false
        }

        return true;
      })}
    >
      <DialogTitle>{props.title ?? t("notifications.bulk_delete_title")}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
          {props.message ?? t("notifications.bulk_delete_content")}
        </DialogContentText>
      </DialogContent>
    </ActionPopup>
  );
};
